import React from "react";
import CodeIcon from "@material-ui/icons/Code";
import { Box, CardActions, CircularProgress, IconButton, useTheme } from "@material-ui/core";
import { Dropzone, DropzoneBox, MaterialCardContent } from "components";
import { CreativeCard, CreativeToolbarContainer } from "pages/MaterialSpecs/components/CreativesSection";
import { CardHeader, CardSubheader } from "components/MaterialCard";
import { useTranslation } from "react-i18next";
import { CardContentHeader } from "./OptionalCreative.styled";

interface OptionalCreativeProps {
    sizeLabel?: string;
    isUploading: boolean;
    dimensions: ClientRect | null;
    selected: boolean;
    onDrop: <T extends File>(acceptedFiles: T[]) => void;
    onToggleThirdPartyMaterial(): void;
}

export const OptionalCreative = ({
    dimensions,
    onDrop,
    sizeLabel = "",
    isUploading,
    selected,
    onToggleThirdPartyMaterial,
}: OptionalCreativeProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <CreativeCard selected={selected}>
            {dimensions && (
                <Box onClick={onToggleThirdPartyMaterial}>
                    <CardContentHeader style={{ padding: `${theme.spacing(1)}px` }}>
                        <CardHeader label={t("campaign.label.optionalDropzone")} />
                        <CardSubheader label={sizeLabel} />
                    </CardContentHeader>
                    <MaterialCardContent>
                        <DropzoneBox display="flex" alignItems="center" justifyContent="center" width="100%">
                            {isUploading ? (
                                <CircularProgress color="primary" size={40} />
                            ) : (
                                <Dropzone label={t("campaign.label.dragAndDropArea")} onDrop={onDrop} />
                            )}
                        </DropzoneBox>
                    </MaterialCardContent>
                    <CardActions>
                        <CreativeToolbarContainer>
                            <IconButton disableRipple={true}>
                                <CodeIcon />
                            </IconButton>
                        </CreativeToolbarContainer>
                    </CardActions>
                </Box>
            )}
        </CreativeCard>
    );
};
